import React from 'react';
import { Link } from 'react-router-dom';
import { useScript } from '../context/ScriptContext';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

const NotFoundPage: React.FC = () => {
  const { t } = useScript();
  useDocumentTitle(t('404 — Страница није пронађена'), '/404');

  return (
    <div className="not-found-page">
      <div className="not-found-content">
        <div className="not-found-cross">{'\u2626'}</div>
        <h1 className="not-found-code">404</h1>
        <h2 className="not-found-title">{t("Страница није пронађена")}</h2>
        <p className="not-found-message">
          {t("Страница коју тражите не постоји или је премештена.")}
        </p>
        <Link to="/" className="not-found-btn">
          {t("Назад на почетну")}
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
